"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUsersCsvResponseToJSON = exports.GetUsersCsvResponseFromJSONTyped = exports.GetUsersCsvResponseFromJSON = void 0;
var _1 = require("./");
function GetUsersCsvResponseFromJSON(json) {
    return GetUsersCsvResponseFromJSONTyped(json, false);
}
exports.GetUsersCsvResponseFromJSON = GetUsersCsvResponseFromJSON;
function GetUsersCsvResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'users': (json['users'].map(_1.UserLvlFromJSON)),
    };
}
exports.GetUsersCsvResponseFromJSONTyped = GetUsersCsvResponseFromJSONTyped;
function GetUsersCsvResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'users': (value.users.map(_1.UserLvlToJSON)),
    };
}
exports.GetUsersCsvResponseToJSON = GetUsersCsvResponseToJSON;
